"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.__atha = void 0;
var sendPageView_1 = __importDefault(require("./events/sendPageView"));
var sendAuctionResult_1 = __importDefault(require("./events/sendAuctionResult"));
var sendBid_1 = __importDefault(require("./events/sendBid"));
var sendImpression_1 = __importDefault(require("./events/sendImpression"));
var sendRequest_1 = __importDefault(require("./events/sendRequest"));
var sendSkip_1 = __importDefault(require("./events/sendSkip"));
// atha.ts
//
// this file contains all the functions available to send atha (ad tech health assesment)
// events into our backend for tracking.
//
// this file is duplicated as atha.js in frontend. Any updates to atha
// should also be done there.
exports.__atha = (function () {
    // the actual user interface for ATHA
    return {
        sendPageView: sendPageView_1.default,
        sendRequest: sendRequest_1.default,
        sendBid: sendBid_1.default,
        sendAuctionResult: sendAuctionResult_1.default,
        sendImpression: sendImpression_1.default,
        sendSkip: sendSkip_1.default,
    };
})();
